import React, { useEffect, useRef, useState } from 'react';
import styles from './BoxWithFullWidthImage.module.scss';
import { sanitizeType } from 'functions';
import { Link } from 'react-router-dom';
import { addCustomPathToLink, TitleOverlayWrapper } from '../../functions';

const BoxWithFullWidthImage = ({ api, type }) => {
  const titleWrapperRef = useRef();
  const [date, setDate] = useState();
  const { event_start, event_end } = api.attributes;
  useEffect((_) => {
    const currentDate = new Date().toISOString();
    setDate(currentDate);
  }, []);

  if (!!event_start && !!event_end && (!date || event_start > date || date > event_end)) return null;

  return (
    <section
      id={api?.id}
      className={styles.SectionNavigation}
      data-aos="fade-up"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
    >
      <picture className={styles.containerImage}>
        <source media="(min-width:992px)" srcSet={addCustomPathToLink(api.attributes.image.src, true)} alt={api.attributes.image.alt} />
        <img className={styles.imageBackground} src={addCustomPathToLink(api.attributes.imageDesk.src, true)} alt={api.attributes.imageDesk.alt} />
      </picture>
      {api.attributes.badge && (
        <div
          className={`${styles.badge} ${
            styles[
              `badge${
                api.attributes.badge == 'news'
                  ? 'New'
                  : api.attributes.badge == 'special-offer'
                  ? 'Ofert'
                  : api.attributes.badge == 'promo'
                  ? 'Promo'
                  : ''
              }`
            ]
          }`}
        >
          <p className={styles.badgeTitle}>
            {api.attributes.badge == 'news'
              ? 'Nowości'
              : api.attributes.badge == 'special-offer'
              ? 'Oferta specjalna'
              : api.attributes.badge == 'promo'
              ? 'Promocje'
              : null}
          </p>
        </div>
      )}

      <TitleOverlayWrapper styles={styles} titleWrapperRef={titleWrapperRef}>
        <div
          ref={titleWrapperRef}
          className={styles.textContent}
          data-aos="fade-right"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
        >
          {(api.attributes.title || api.attributes.desc) && (
            <div className={styles.containerBoxContent}>
              <div className={styles.boxContent}>
                {api.attributes.title && <h2 className={styles.title}>{api.attributes.title}</h2>}
                {api.attributes.desc && <p className={styles.desc}>{api.attributes.desc}</p>}
              </div>

              {api.attributes.btnLink && (
                <a className={styles.linkNav} href={addCustomPathToLink(`${api.attributes.btnLink}`)} target="_blank">
                  {api.attributes.btnText}
                </a>
              )}
            </div>
          )}
          {!(api.attributes.title || api.attributes.desc) && api.attributes.btnLink && (
            <a className={styles.linkNav} href={addCustomPathToLink(`${api.attributes.btnLink}`)} target="_blank">
              {api.attributes.btnText}
            </a>
          )}
        </div>
      </TitleOverlayWrapper>
    </section>
  );
};
export default BoxWithFullWidthImage;
